const LIFE = "life";
const LTC = "ltc";
const DISABILITY = "disability";
const ANNUITY = "annuity";

export { LIFE, LTC, DISABILITY, ANNUITY };
